import { useEffect } from 'react';

import { useLocation, useNavigate } from '@utils/hooks';

import { useStore } from '@modules';
import { IbanStatusesEnum, VerificationStatusesEnum } from '@modules/user/types';

const { failed, need_email, under_review, incomplete } = VerificationStatusesEnum;
const { forbidden } = IbanStatusesEnum;

const useDefaultRedirect = (): void => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [{ user, login }] = useStore();
  const { data: userData } = user;
  const iban_status = userData?.iban_status;
  const isIbanForbidden = iban_status === forbidden;

  const isAccountPage = pathname.startsWith(CONST.nav.accounts);

  const documentStatus = userData?.checks.document;
  const checkEnabled = userData?.checks.document_details.check_enabled;
  const documentFailed = documentStatus === failed;
  const reviewErrors = userData?.checks.review_status?.errors;
  const documentDuplicate = reviewErrors?.includes('DUPLICATE');
  const isKYCFailed = documentFailed && !checkEnabled && !documentDuplicate;
  const POAStatus = userData?.checks.proof_of_address;

  const hasUserEmail = userData?.email;
  const isEmailSettingsRoute = pathname === CONST.nav.profileSetEmail;
  const isNeedEmailStatus = documentStatus === need_email;
  const shouldSetEmail = isNeedEmailStatus && !hasUserEmail && !isEmailSettingsRoute;

  useEffect(() => {
    if (isAccountPage && isIbanForbidden && POAStatus !== under_review) navigate(CONST.nav.root);
    if (isKYCFailed) navigate(CONST.nav.kycBlocked);
    else if (documentDuplicate) navigate(CONST.nav.accountExists);
    else if (shouldSetEmail) navigate(CONST.nav.profileSetEmail);
    else if (
      login.loaders.login === false &&
      (documentStatus === incomplete || (documentStatus === failed && checkEnabled))
    ) {
      navigate<'verifyIdentity'>(CONST.nav.verifyIdentity, { state: { fromLogin: true } });
    }
  }, [userData]);
};

export default useDefaultRedirect;
